<template>
  <div class="homeContainer">
    <head-top></head-top>
    <div class="noticeDiv contentWidth">
      <p class="title">平台公告</p>
      <div class="noticeList">
        <div v-for="(item, index) in list" :key="item.id" class="noticeItem flex-space-between" @click="toDetails(index)">
          <span class="itemTitle">{{item.title}}</span>
          <span class="time">{{item.time}}</span>
        </div>
      </div>
      <pagination :count="count" :page-no="searchForm.pageNo" :size="searchForm.pageSize" @changePage="value => { searchForm.pageNo = value;getList() }"></pagination>
    </div>
    <foot-btm></foot-btm>
  </div>
</template>

<script>
import pagination from '@/components/pagination'
import headTop from '@/components/layout/headTop'
import footBtm from '@/components/layout/footBtm'
const Mock = require('mockjs')
export default {
  name: 'index',
  components: {
    pagination,
    headTop,
    footBtm
  },
  data () {
    return {
      list: [],
      count: 0,
      searchForm: {
        pageNo: 1,
        pageSize: 10
      }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      const res = Mock.mock(require('@/mock/json/notice'))
      this.list = res.noticeList
      this.count = res.count
    },
    toDetails (index) {
      this.$router.push({
        name: 'noticeDetails',
        query: {
          index: index
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.homeContainer{
  background: #f7f8fb;
  height: 100%;
  overflow: auto;
  .noticeDiv{
    background: #fff;
    margin-top: 41px;
    padding-bottom: 40px;
    .title{
      width: 100%;
      height: 60px;
      line-height: 60px;
      background: #E8EBF3;
      font-size: 18px;
      padding-left: 41px;
      box-sizing: border-box;
    }
    .noticeList{
      padding: 0 41px;
      .noticeItem{
        cursor: pointer;
        width: 100%;
        border-bottom: solid 1px #E8EBF3;
        height: 60px;
        line-height: 60px;
        span{
          display: inline-block;
        }
        .itemTitle{
          width: calc(100% - 80px);
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .time{
          width: 80px;
          color: #999;
        }
      }
    }
  }
  .tips{
    width: 100%;
    font-size: 14px;
    color: #999;
    margin: 40px 0;
    text-align: center;
  }
}
</style>
